export default __webpack_public_path__ + "static/media/en.7bcb11b8.png";